import React, {useCallback, useMemo, useRef, useState} from "react";
import {throttle} from "../../../utils/Throttle";
import {ImageOverlayCard} from "./ImageOverlayCard";

export const HospitalitySection: React.FC = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [offset, setOffset] = useState({x: 0, y: 0});

    const handleMouseMoveLogic = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
        if (!containerRef.current) return;
        const {width, height, left, top} = containerRef.current.getBoundingClientRect();
        const x = (e.clientX - left) / width - 0.5;
        const y = (e.clientY - top) / height - 0.5;
        setOffset({x, y});
    }, [])

    const throttleMouseMove = useMemo(
        () => throttle(handleMouseMoveLogic, 50),
        [handleMouseMoveLogic]
    )

    const handleMouseLeave = () => {
        setOffset({x: 0, y: 0});
    };

    const card1Movement = window.innerWidth < 1024 ? 0 : 40;
    const card2Movement = window.innerWidth < 1024 ? 0 : 20;

    const getCardStyle = (movement: number): React.CSSProperties => {
        const style: React.CSSProperties = {
            transform: `translateX(${offset.x * movement}px) translateY(${offset.y * movement}px) translateZ(0)`,
            willChange: 'transform',
            transition: 'transform 0.1s linear'
        };
        if (offset.x === 0 && offset.y === 0) {
            style.transition = 'transform 0.5s cubic-bezier(0.23, 1, 0.32, 1)';
        }
        return style;
    };

    return (
        <section
            id="hospitality-section"
            className="snap-section py-4 sm:py-6 lg:py-8 bg-dark-mode text-ivory flex flex-col h-auto lg:h-[calc(100vh-4rem)]"
        >
            <div className="flex-1 flex flex-col px-4 sm:px-6 lg:px-8">
                {/* Title */}
                <h2 className="heading-font uppercase text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-center text-ivory mb-6 sm:mb-8 lg:mb-12 leading-tight">
                    Hospitality
                </h2>

                {/* Card Grid */}
                <div
                    ref={containerRef}
                    onMouseMove={throttleMouseMove}
                    onMouseLeave={handleMouseLeave}
                    className="relative flex-grow min-h-0 flex flex-col lg:grid lg:grid-cols-5 items-stretch lg:items-center gap-4 sm:gap-6 lg:gap-8"
                >
                    <ImageOverlayCard
                        imageSrc="/images/room_1.webp"
                        altText="Room Preview"
                        title="ROOMS & STAY"
                        className="md:col-span-2"
                        style={getCardStyle(card1Movement)}
                    />
                    <ImageOverlayCard
                        imageSrc="/images/banquet_1.webp"
                        altText="Banquets Preview"
                        title="BANQUETS"
                        className="md:col-span-3"
                        style={getCardStyle(card2Movement)}
                    />
                </div>
            </div>
        </section>
    );
};